import { createClient, type SanityClient } from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";
import type { SanityImageSource } from "@sanity/image-url/lib/types/types";

// Read from Vite env. If not set, the client still instantiates but requests
// will fail loudly, which is better than silent empty data.
const projectId = import.meta.env.VITE_SANITY_PROJECT_ID as string | undefined;
const dataset = (import.meta.env.VITE_SANITY_DATASET as string | undefined) ?? "production";
const apiVersion = (import.meta.env.VITE_SANITY_API_VERSION as string | undefined) ?? "2024-10-01";

if (!projectId) {
  // Helpful console message in dev — the app will still render with fallback content.
   
  console.warn(
    "[sanity] VITE_SANITY_PROJECT_ID is not set. Copy .env.example to .env.local and add your Sanity project ID."
  );
}

export const sanity: SanityClient = createClient({
  projectId: projectId ?? "missing-project-id",
  dataset,
  apiVersion,
  useCdn: true, // use CDN for fast, cached reads; flip to false for fresh drafts
  perspective: "published",
});

const builder = imageUrlBuilder(sanity);
export const urlFor = (source: SanityImageSource) => builder.image(source);

// Gracefully fetch — return null on failure so pages can fall back to seeded/local content.
export async function safeFetch<T>(query: string, params: Record<string, unknown> = {}): Promise<T | null> {
  if (!projectId) return null;
  try {
    return await sanity.fetch<T>(query, params);
  } catch (err) {
     
    console.error("[sanity] fetch failed", err);
    return null;
  }
}
